import {Box, Button, CircularProgress, TextField} from "@mui/material";
import React, {useState} from "react";
import SubmitOfferCard from "./submit-offer-item";
import {isLogin} from "../../../tools/Helper";
import Typography from "@mui/material/Typography";
import {useLocation, useNavigate} from "react-router-dom";

const SubmitOfferForm = ({
                             handleloading,
                             handleChange,
                             handleButtonClick,
                             formData,
                             offer,
                             panelExist,
                             responseMessage
                         }) => {
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");

    const location = useLocation();
    const navigate = useNavigate();
    // const validateUrl = (value) => {
    //   if (value.trim() === "") {
    //     // Reset error state if the input is empty
    //     setError(false);
    //     setHelperText("");
    //     return;
    //   }

    //   const urlPattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]{2,}\.[a-z]{2,}(\.[a-z]{2,})?$/;
    //   if (!urlPattern.test(value)) {
    //     setError(true);
    //     setHelperText("Please enter a valid URL (e.g., https://example.com)");
    //   } else {
    //     setError(false);
    //     setHelperText("");
    //   }
    // };

    const handleLoginClick = async () => {

        navigate("/login", {state: {from: location}});
    };
    const handleAddPanelClick = async () => {

        navigate("/AddPanel", {state: {from: location}});
    };
    return (
        <form onSubmit={handleButtonClick}>
            <Box sx={{marginTop: "40px"}}>
                <TextField
                    fullWidth
                    onChange={(e) => {
                        const url = e.target.value;
                        handleChange(undefined, "panel_url", url);
                    }}
                    required
                    variant="outlined"
                    label="Enter the panel URL link"
                    placeholder="Enter the panel URL link (e.g., https://example.com)"
                    sx={{
                        marginBlock: "20px",
                        background: "#FFF",
                        borderRadius: 2,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                />
                <Box>
                    {offer?.offerDetails?.map((detail, index) => {
                        return (
                            <SubmitOfferCard
                                index={index}
                                detail={detail}
                                formData={formData}
                                handleChange={handleChange}
                            />
                        );
                    })}
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                }}
            >
                {
                    isLogin ?
                        (
                          panelExist ?
                              <Button
                                  variant="contained"
                                  sx={{
                                      background: "linear-gradient(135deg, #FF8A00, #ECA601)",
                                      color: "#FFF",
                                      padding: "10px 70px",
                                      fontSize: "18px",
                                      fontWeight: "bold",
                                      borderRadius: "15px",
                                      transition: "transform 0.2s",
                                      "&:hover": {
                                          background: "linear-gradient(135deg, #ECA601, #FF8A00)",
                                          transform: "translateY(-5px)",
                                      },
                                  }}
                                  type="submit"
                              >
                                  {handleloading ? (
                                      <CircularProgress size={22} sx={{color: "white"}}/>
                                  ) : (
                                      "Submit"
                                  )}
                              </Button> :
                              <Box
                                  sx={{
                                      textAlign:'center'
                                  }}>
                                  <Typography
                                      sx={{
                                          fontSize: "18px",
                                          lineHeight: "20px",
                                          fontWeight: "400",
                                          color: "#474747",
                                          textAlign: "center",
                                          margin: "30px",
                                      }}
                                  >
                                      {responseMessage}

                                  </Typography>
                                  <Button
                                      variant="contained"
                                      color="primary"
                                      sx={{
                                          textTransform: "none",
                                          whiteSpace: "nowrap",
                                          background: "#ECA601",
                                          padding: "10px 50px",
                                          borderRadius: "10px",
                                          // Adding inner shadow using a pseudo-element
                                          color: "#F1F5FD",
                                          position: "relative",
                                          lineHeight: "20px",
                                          overflow: "hidden",
                                          fontWeight: "700",
                                          fontSize: "18px",
                                          boxShadow: "0px 3px 3px #00000040", // Outer shadow
                                          "&:before": {
                                              content: '""',
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              right: 0,
                                              bottom: 0,
                                              borderRadius: "0 20px 20px 0",
                                              background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                                              filter: "blur(4px)",
                                              zIndex: 1,
                                          },
                                          "&:hover:before": {
                                              background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                                          },
                                      }}
                                      disabled={handleloading}
                                      onClick={handleAddPanelClick}
                                  >
                                      {handleloading ? (
                                          <CircularProgress size={22} sx={{ color: "white" }} />
                                      ) : (
                                          "Add Panel"
                                      )}
                                  </Button>
                              </Box>
                        )
                         :
                        <Box
                            sx={{
                                textAlign: 'center'
                            }}>
                            <Typography
                                sx={{
                                    fontSize: "18px",
                                    lineHeight: "20px",
                                    fontWeight: "400",
                                    color: "#474747",
                                    textAlign: "center",
                                    margin: "30px",
                                }}
                            >
                                You Need Login First To Can Buy Get This Offer <br/>

                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    background: "#ECA601",
                                    padding: "10px 50px",
                                    borderRadius: "10px",
                                    // Adding inner shadow using a pseudo-element
                                    color: "#F1F5FD",
                                    position: "relative",
                                    lineHeight: "20px",
                                    overflow: "hidden",
                                    fontWeight: "700",
                                    fontSize: "18px",
                                    boxShadow: "0px 3px 3px #00000040", // Outer shadow
                                    "&:before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        borderRadius: "0 20px 20px 0",
                                        background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                                        filter: "blur(4px)",
                                        zIndex: 1,
                                    },
                                    "&:hover:before": {
                                        background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                                    },
                                }}
                                onClick={handleLoginClick}
                            >

                                Login Now
                            </Button>
                        </Box>
                }

            </Box>
        </form>
    );
};

export default SubmitOfferForm;
